// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tSk0","col":"styles_col__3aZKZ"};